<div class="hemro-horizontal-navigation-wrapper">

  @for (item of navigation; track trackByFn($index, item)) {
    <!-- Skip the hidden items -->
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
      <!-- Basic -->
      @if (item.type === 'basic') {
        <hemro-horizontal-navigation-basic-item
          class="hemro-horizontal-navigation-menu-item"
          [item]="item"
        [name]="name"></hemro-horizontal-navigation-basic-item>
      }
      <!-- Branch: aside, collapsable, group -->
      @if (item.type === 'aside' || item.type === 'collapsable' || item.type === 'group') {
        <hemro-horizontal-navigation-branch-item
          class="hemro-horizontal-navigation-menu-item"
          [item]="item"
          [name]="name"
        (click)="openBranch"></hemro-horizontal-navigation-branch-item>
      }
      <!-- Spacer -->
      @if (item.type === 'spacer') {
        <hemro-horizontal-navigation-spacer-item
          class="hemro-horizontal-navigation-menu-item"
          [item]="item"
        [name]="name"></hemro-horizontal-navigation-spacer-item>
      }
    }
  }

</div>
